export const isAgent360 = (name) => {
    return (['Auto', 'Home', 'Umbrella'].indexOf(name) > -1);
};
